import axios from 'axios'

export function detectMob() {
  return ( ( window.innerWidth <= 800 ));
}

export const axiosInstance = axios.create({
  baseURL: 'https://idex2023.kintsugi.workers.dev',
  timeout: 3000,
})